__turbopack_context__.v({
  "label": "YV25Hq_label",
});
